<div class="hidden md:flex z-[1] absolute top-0 left-0 overflow-hidden h-screen w-screen self-center"><img
        class="min-h-[100vh] min-w-[100vw]" style="object-fit: cover;" src="../../assets/login_background.png"></div>
<div class="w-screen h-screen flex place-content-center items-center bg-tertiary absolute top-0 left-0 z-[2] cut-bg"
    *transloco="let t;prefix:'auth'">
    <div class="md:w-[350px] grid pb-[10vh] h-screen">
        <div title class="text-[48px] pt-[20px] font-bold text-center mx-[18px] text-primary italic">
            <img class="" [src]="'../assets/logoAuth.png'" />
        </div>
        <div><std-input customInputClass="custom-input" customLabel="label-input" [placeholder]="t('email')" customContainerlass="border-b-[2px] border-primary"
                customInputClass="border-0 rounded-none" [(ngModel)]="email" [value]="email" id="email-login"
                type="email">
            </std-input>
            <div (click)="backToLogin()"
                class="text-[#2D2D2D] cursor-pointer w-fit text-[16px] opacity-50 mt-[10px] ml-auto">
                {{t('backToLogin')}}</div>
        </div>
        <div class="ml-auto w-full">
            <std-button (click)="sendEmail()" id="button-login" size="sm"
                buttonClass="uppercase bg-primary hover:bg-primary focus:bg-primary">{{t('sendEmail')}}</std-button>
        </div>
    </div>
</div>